<twc-input-file #inputFile [placeholderTemplate]="placeholderTemplate" [dragOnly]="true" [showWarnings]="showWarnings"
    [addMethod]="addMethod" [maxFiles]="maxFiles" [accept]="accept" (added)="emitAdded($event)"
    (warning)="emitWarning($event)" cwHideListFilesControl [(ngModel)]="files" [cwHideListFiles]="hideListFiles"
    cwEnableDirectoryDrop>
    <ng-template #placeholderTemplate>
        <div *ngIf="!isLoading" class="template-input-file" (click)="onDialogOpen()"
            [ngClass]="{disabled: dialogMode === 'disabled'}">
            <twc-icon shape="cloud-up" class="topcon-blue" [size]="100"></twc-icon>
            {{'UPLOAD.DROPPING_BOX_NOTICE' | translate}}
        </div>
        <twc-loader *ngIf="isLoading"></twc-loader>
    </ng-template>
</twc-input-file>

<div class="twc-row" *ngIf="availableSize && files?.length! > 0">
    <div class="twc-col-12 files-size">
        <span class="twc-body">{{'UPLOAD.SELECTED_FILES' | translate}}</span>
        <span>{{getTotalFilesSize() | bytes}}</span>
    </div>
</div>

<div class="twc-row" *ngIf="hasToShowCurrentAvailableSize">
    <div class="twc-col-12 files-size" [ngClass]="{'without-storage': getCurrentAvailableSize() < 0}">
        <span class="twc-body">{{'UPLOAD.AVAILABLE_STORAGE_AFTER_UPLOAD' | translate}}</span>
        <span>{{getCurrentAvailableSize() | bytes}}</span>
    </div>
</div>